// extracted by mini-css-extract-plugin
export default {"header":"Header_header__fwgtt","headerNav":"Header_headerNav__NEQjH","searchBtn":"Header_searchBtn__6M7FL","headerBtn":"Header_headerBtn__cJ4mP","loginBtn":"Header_loginBtn__z9MHz"};